import React from "react";
import {useTranslation} from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PageHeader, { parentRoutes } from "../../../components/Header/PageHeader";
import { Form } from "../../../components/Form/Form"
import { faArrowProgress } from '@fortawesome/pro-light-svg-icons/faArrowProgress';
import {createEgressCredential} from '../../../actions/actionEgressProvider';
import EgressCredentialForm from "../EgressCredentialForm/EgressCredentialForm";

const parentRouteList = parentRoutes('/egress_providers')
const newRoutes = [
    ...parentRouteList.routes,
    {name: "generic.create",path:"/update_egress_provider",isActive: true},
];

const tabList = [
    { name: 'generic.create', key: 'form' },
]

export default function CreateEgressCredential(props) {
    const { t } = useTranslation('common');
    const currentProvider = props.match.params.id
    const onSuccess = () => {
        props.history.push(`/update_egress_provider/${currentProvider}?tab=credential`);
    }

    return (
        <div>
        <PageHeader location={props.location} routes={typeof newRoutes !== 'undefined' ? newRoutes : null} title={t('egress_provider.create-egress-credential')} icon={<FontAwesomeIcon icon={faArrowProgress} />} />
        <Form 
            {...props}
            tabList={tabList}
            currentTab="form"
            section="egress_provider"
            dispatchFunc={createEgressCredential}
            onSuccess={onSuccess}
            form={<EgressCredentialForm {...props} />}
        />
    </div>
    )
}
